<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="900"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text px-10"
        block
        v-on="on"
      >
        Create
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Contribution or Deductions"
      text="Create contribution or deductions"
      class="mb-0"
      :loading="loading"
    > 
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="code"
                v-validate="'required'" 
                label="Code"
                :error-messages="errors.collect('code')"
                data-vv-name="code"
                outlined 
                data-vv-as="code" 
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="name"
                v-validate="'required'" 
                label="Name"
                :error-messages="errors.collect('name')"
                data-vv-name="name"    
                data-vv-as="name"
                outlined
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-8"
            >
              <tiptap-vuetify
                v-model="description"
                class="full-width text-editor-toolbar-height pb-1"
                placeholder="Description"
                :extensions="extensions"
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-autocomplete
                v-model="type" 
                v-validate="'required'"
                :error-messages="errors.collect('type')"    
                data-vv-name="type" 
                data-vv-as="type"
                label="Type"
                item-text="name"
                item-value="id"
                :items="types"
                outlined
              />
            </v-col>

            <v-col
              v-if="type ==='tax'"
              cols="12"
              class="py-0"
            >
              <span>Deduct EPF? </span>
              <v-radio-group
                v-model="isDeductEPF"
                class="mt-0"
                row
              >
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
                <v-radio
                  label="No"
                  :value="0"
                />
              </v-radio-group>
            </v-col>

            <v-col
              v-if="type ==='rbf'"
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="retirementAge"
                label="Retirement Age"
                type="number"
                :min="0"
                @keydown.native="['e', 'E', '+', '-', '.'].includes($event.key) && $event.preventDefault()"
              />
            </v-col>

            <v-col
              v-if="type ==='epf'"
              cols="12"
              class="py-0"
            >
              <v-row>
                <v-col
                  cols="6"
                  class="py-0"
                >
                  <v-text-field
                    v-model="employeeEpfRate"
                    v-validate="employeeEpfAmount ? '':'required|oneDecimalValue|pointFive'"
                    :error-messages="errors.collect('employeeEpfRate')"  
                    data-vv-name="employeeEpfRate"
                    data-vv-as="employee EPF rate"
                    label="Employee EPF Rate Exceed Table Limit"
                    type="number"
                    suffix="%"
                    clearable
                    :disabled="employeeEpfAmount ? true : false"
                    :filled="employeeEpfAmount ? true : false"
                    :min="0"
                    @keydown.native="['e', 'E', '+', '-'].includes($event.key) && $event.preventDefault()"
                    @change="employeeEpfAmount = null"
                  />
                </v-col>
                <v-col
                  cols="6"
                  class="py-0"
                >
                  <v-text-field
                    v-model="employeeEpfAmount"
                    v-validate="employeeEpfRate ? '':'required|twoDecimalValue'"
                    label="Employee EPF Amount"
                    :error-messages="errors.collect('employeeEpfAmount')"  
                    data-vv-name="employeeEpfAmount"
                    data-vv-as="employee EPF amount"
                    type="number"
                    prefix="RM"
                    clearable
                    :disabled="employeeEpfRate ? true:false"
                    :filled="employeeEpfRate ? true:false"
                    :min="0"
                    @keydown.native="['e', 'E', '+', '-'].includes($event.key) && $event.preventDefault()"
                    @change="employeeEpfRate = null"
                  />
                </v-col>
                <v-col
                  cols="6"
                  class="py-0"
                >
                  <v-text-field
                    v-model="employerEpfRate"
                    v-validate="employerEpfAmount ? '':'required|oneDecimalValue|pointFive'"
                    :error-messages="errors.collect('employerEpfRate')"  
                    data-vv-name="employerEpfRate"
                    data-vv-as="employer EPF rate"
                    label="Employer EPF Rate Exceed Table Limit"
                    type="number"
                    suffix="%"
                    clearable
                    :disabled="employerEpfAmount ? true:false"
                    :filled="employerEpfAmount ? true:false"
                    :min="0"
                    @keydown.native="['e', 'E', '+', '-'].includes($event.key) && $event.preventDefault()"
                    @change="employerEpfAmount = null"
                  />
                </v-col>
                <v-col
                  cols="6"
                  class="py-0"
                >
                  <v-text-field
                    v-model="employerEpfAmount"
                    v-validate="employerEpfRate ? '':'required|twoDecimalValue'"
                    :error-messages="errors.collect('employerEpfAmount')"  
                    data-vv-name="employerEpfAmount"
                    data-vv-as="employer EPF amount"
                    label="Employer EPF Amount"
                    type="number"
                    prefix="RM"
                    clearable
                    :disabled="employerEpfRate || employerEpfSpecialCaseRate ? true : false"
                    :filled="employerEpfRate || employerEpfSpecialCaseRate ? true : false"
                    :min="0"
                    @keydown.native="['e', 'E', '+', '-'].includes($event.key) && $event.preventDefault()"
                    @change="employerEpfRate = null; employerEpfSpecialCaseRate = null"
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-text-field
                    v-model="employerEpfSpecialCaseRate"
                    v-validate="employerEpfAmount ? '' : 'oneDecimalValue|pointFive'"
                    :error-messages="errors.collect('employerEpfSpecialCaseRate')"  
                    data-vv-name="employerEpfSpecialCaseRate"
                    data-vv-as="employer EPF special case rate"
                    label="Employer EPF Rate when wages received are RM5000 and below and upon sum with bonus exceed RM5000"
                    type="number"
                    suffix="%"
                    clearable
                    :disabled="employerEpfAmount ? true : false"
                    :filled="employerEpfAmount ? true : false"
                    :min="0"
                    @keydown.native="['e', 'E', '+', '-'].includes($event.key) && $event.preventDefault()"
                    @change="employerEpfAmount = null"
                  />
                </v-col>
              </v-row>
            </v-col> 
          </v-row>
        </v-container> 
      </form> 
      
      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"           
          @click="submitForm"
        >
          Save
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import Big from 'big.js'
  import { TiptapVuetify, Heading, Bold, Italic, Underline, BulletList, OrderedList, ListItem, Link, HardBreak } from 'tiptap-vuetify'

  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    components: {
      TiptapVuetify,
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        loading: false,
        code: null,
        description: null,
        type: null,
        types: [
          // { id: 'baitulmal', name: 'BAITULMAL' },
          { id: 'eis', name: 'EIS' },
          { id: 'epf', name: 'EPF' },
          // { id: 'grt', name: 'GRT' },
          // { id: 'hrd', name: 'HRD' },
          // { id: 'rbf', name: 'RBF' },
          { id: 'socso', name: 'SOCSO' },
          { id: 'tax', name: 'TAX' },
          // { id: 'zakat', name: 'ZAKAT' },
        ],
        isDeductEPF: 0,
        name: null,
        retirementAge: null,
        extensions: [
          Link,
          Underline,
          Italic,
          ListItem,
          BulletList,
          OrderedList,
          [Heading, {
            options: {
              levels: [1, 2, 3],
            },
          }],
          Bold,
          HardBreak,
        ],
        employeeEpfRate: null,
        employerEpfRate: null,
        employerEpfSpecialCaseRate: null,
        employeeEpfAmount: null,
        employerEpfAmount: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()
        this.loading = true

        let _this = this
        this.$validator.extend('twoDecimalValue', {
          getMessage (field, args) {
            return 'Only 2 Decimals are allowed'
          },
          validate (value, args) {
            return _this.isValidNumbers(value)
          },
        })

        this.$validator.extend('oneDecimalValue', {
          getMessage (field, args) {
            return 'Only 1 decimal allowed'
          },
          validate (value, args) {
            return (new Big(value).times(1000) % 100 === 0)
          },
        })

        this.$validator.extend('pointFive', {
          getMessage (field, args) {
            return 'Only 0.5 is allowed'
          },
          validate (value, args) {
            if (value.indexOf('.') > -1) {
              let arr = [...value.split('.')[1]]
              return arr[0] === '5' || arr[0] === '0'
            } else {
              return true
            }
          },
        })
     
        this.loading = false
      },
    },

    methods: { 
      prepareFormData () {
        return {
          code: this.code,
          name: this.name,
          description: this.description,
          type: this.type,
          is_deduct_epf: this.isDeductEPF,
          retirement_age: this.retirementAge,
          employee_epf_default_rate: this.employeeEpfRate,
          employee_epf_default_amount: this.employeeEpfAmount,
          employer_epf_default_rate: this.employerEpfRate,
          employer_epf_special_case_rate: this.employerEpfSpecialCaseRate,
          employer_epf_default_amount: this.employerEpfAmount,
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)
    
            this.$api.contributionDeductions().create(this.prepareFormData())
              .then((response) => {
                if (response.status === 200 || response.status === 201) {
                  this.$emit('created')                
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false       
                }
              })
              .catch(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },

      isValidNumbers (value) {
        return (new Big(value).times(10000) % 100 === 0)
      },
    },
  }
</script>

<style scoped>
.text-editor-toolbar-height>>> .v-toolbar__content{
  height: unset !important;
  min-height: 42px;
}
.text-editor-toolbar-height>>>.v-sheet.v-sheet--tile.theme--light.v-toolbar.v-toolbar--dense.v-toolbar--flat.grey.lighten-4{
  min-height:unset !important;
}
.full-width{
  width: 100%;
}
</style>
